export const MAX_DISPLAYED_HOTSPOTS_COUNT = 10;
export const HOTSPOT_TYPE = {
  PIP_HOTSPOTS: 'pip_hotspots',
  DRAWER_HOTSPOTS: 'drawer_hotspots',
  LENS_HOTSPOTS: 'lens_hotspots',
};
